import { PureComponent } from "react";
import colors from "styles/colors";

import SearchIcon from "/static/svg/icons/search.svg";

import { StylesDirectoryHeaderContentComponent } from "./directory-header-content-component.scss";

export default class DirectoryHeaderContentComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.onInputChange = this.onInputChange.bind(this);
  }

  shouldShowSearch() {
    const { searchConfig } = this.props;
    return searchConfig && searchConfig.show;
  }

  onInputChange(event) {
    const { onSearchChange } = this.props;
    const { value } = event.target;

    return onSearchChange(value);
  }

  render() {
    const { title, subtitle, textColor, searchConfig, searchValue, onSearchChange } = this.props;

    return (
      <StylesDirectoryHeaderContentComponent className="directory-header-content-component">
        <h1 dangerouslySetInnerHTML={{ __html: title }} style={{ color: colors[textColor] }} />
        <h2 dangerouslySetInnerHTML={{ __html: subtitle }} style={{ color: colors[textColor] }} />

        {this.shouldShowSearch() && (
          <div className="search-input-wrapper">
            <input placeholder={searchConfig.placeholder} value={searchValue || ""} onChange={this.onInputChange} />

            <div className="search-icon-container">
              <SearchIcon />
            </div>
          </div>
        )}
      </StylesDirectoryHeaderContentComponent>
    );
  }
}
